/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ years: NonNullable<unknown> }} Onboarding_V1_Projection_Results_LabelInputs */

const en_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Values after ${i?.years} years`)
};

const de_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Werte nach ${i?.years} Jahren`)
};

const pt_br2_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Valores após ${i?.years} anos`)
};

const tr_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years} yıl sonraki değerler`)
};

const zh_cn2_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years}年后的价值`)
};

const zh_hk2_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years}年後的價值`)
};

const ko_kr2_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.years}년 후 가치`)
};

const ru_ru2_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Стоимость через ${i?.years} лет`)
};

const es_419_onboarding_v1_projection_results_label = /** @type {(inputs: Onboarding_V1_Projection_Results_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Valores después de ${i?.years} años`)
};

/**
* | output |
* | --- |
* | "Values after {years} years" |
*
* @param {Onboarding_V1_Projection_Results_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_results_label = /** @type {((inputs: Onboarding_V1_Projection_Results_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_Results_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_results_label(inputs)
	if (locale === "de") return de_onboarding_v1_projection_results_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_results_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_results_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_results_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_results_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_results_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_results_label(inputs)
	return es_419_onboarding_v1_projection_results_label(inputs)
});